export const downloadUrl = (url: string) => {
    Array.from(document.getElementsByClassName('js-download-url-iframe')).forEach((el) => el.remove());

    const el = document.createElement('iframe');

    el.src = url;
    el.className = 'js-download-url-iframe u-hiddenVisually';
    document.body.appendChild(el);
};
